import React from 'react';
import { ArrowIcon } from '../icons';

export default function UrlIngestMode({ urlInput, setUrlInput, urlError, setUrlError, urlLoading, onSubmit }) {
  return (
    <div className="doc-mode-area">
      <div className="doc-url-row">
        <input
          className="doc-url-input"
          type="url"
          placeholder="https://…"
          value={urlInput}
          onChange={e => { setUrlInput(e.target.value); setUrlError(null); }}
          onKeyDown={e => e.key === 'Enter' && onSubmit()}
          disabled={urlLoading}
          autoFocus
        />
        <button
          className="doc-url-submit"
          onClick={onSubmit}
          disabled={urlLoading || !urlInput.trim()}
          title="Fetch and index this URL"
        >
          {urlLoading ? '…' : <ArrowIcon />}
        </button>
      </div>
      {urlError && <div className="documents-error">{urlError}</div>}
    </div>
  );
}
